module.exports = __webpack_public_path__ + "img/law1-m@1.4acdceae.webp";